import React, { FunctionComponent } from 'react'
import { Pane, majorScale, Heading, Card, Text, Icon, Button, minorScale } from 'evergreen-ui'
import MenuPopover from './MfaOptionMenuPopover'
import VerifiedPanel from './MfaOptionVerifiedPanel'
import { MfaOptionTypes } from '../MfaApp'

interface MfaOptionProps {
  type: MfaOptionTypes
  phoneNumber?: string | null
  isEnabled: boolean | null
  configureTfaMethod: (type: MfaOptionTypes) => void
  onDisableClick: () => void
}

const MfaOption: FunctionComponent<MfaOptionProps> = props => {
  const { type, isEnabled, configureTfaMethod, phoneNumber, onDisableClick } = props

  const heading = type === 'sms' ? 'Text Message' : 'Authenticator App'
  const description =
    type === 'sms'
      ? 'Use your mobile phone to receive security codes. SMS deliverability is only available in US or Canada.'
      : 'Use an authenticator app to generate one time security codes.'

  return (
    <Pane marginTop={majorScale(2)}>
      <Card elevation={1} background="white">
        <Pane display="flex" alignItems="flex-start" justifyContent="space-between" padding={majorScale(2)}>
          <Pane display="flex" flexDirection="column" flexBasis="0" flex="1">
            <Heading size={400}>{heading}</Heading>
            <Text>{description}</Text>
          </Pane>

          <Pane display="flex">
            {isEnabled ? (
              <MenuPopover onDisableClick={onDisableClick} />
            ) : (
              <Button
                appearance="minimal"
                display="flex"
                alignItems="center"
                flexShrink={0}
                height="auto"
                paddingY={minorScale(1)}
                paddingLeft={majorScale(1)}
                paddingRight={minorScale(1)}
                size={400}
                onClick={() => configureTfaMethod(type)}
              >
                Set up
                <Icon icon="caret-right" color="muted" />
              </Button>
            )}
          </Pane>
        </Pane>

        {isEnabled && <VerifiedPanel phoneNumber={phoneNumber} />}
      </Card>
    </Pane>
  )
}

export default MfaOption
